<div class="mini-upload-wrapper" [class.mini-upload-pill]="variant === 'pill'">
  <label
    class="mini-upload-card"
    [class.mini-upload-card-pill]="variant === 'pill'"
    [class.disabled]="disabled"
    [class.uploaded]="!!value"
    [title]="label || 'Upload'"
  >
    <input
      type="file"
      [accept]="accept"
      [disabled]="disabled"
      (change)="onChange($event)"
    />

    <ng-container *ngIf="variant === 'pill'; else squareTpl">
      <img
        *ngIf="value && iconSrc"
        class="mini-upload-pdf-icon"
        [src]="iconSrc"
        alt=""
        aria-hidden="true"
      />
      <img
        *ngIf="!iconSrc && value && isImage(value)"
        class="mini-upload-thumb-pill"
        [src]="value"
        alt="Uploaded"
      />
      <img
        *ngIf="!iconSrc && value && !isImage(value)"
        class="mini-upload-pdf-icon"
        src="assets/icons/attachmentRed.svg"
        alt=""
        aria-hidden="true"
      />
      <img
        *ngIf="!value && placeholderIconSrc"
        class="mini-upload-pdf-icon"
        [src]="placeholderIconSrc"
        alt=""
        aria-hidden="true"
      />
      <img
        *ngIf="!value && !placeholderIconSrc && !hidePlaceholderIcon"
        class="mini-upload-pill-photo-icon"
        src="assets/images/aquila-placeholder.svg"
        alt=""
        aria-hidden="true"
      />
      <span class="mini-upload-pill-text" *ngIf="!value">
        <span class="mini-upload-pill-label">{{ label }}</span>
        <span class="mini-upload-pill-hint">{{ formatsHint }}</span>
      </span>
      <span class="mini-upload-pill-label-uploaded" *ngIf="value">{{
        effectiveUploadedLabel
      }}</span>
    </ng-container>

    <ng-template #squareTpl>
      <ng-container *ngIf="value && !iconSrc; else placeholder">
        <img
          *ngIf="isImage(value); else fileIcon"
          class="upload-thumb"
          [src]="value"
          alt="Uploaded file"
        />
        <ng-template #fileIcon>
          <img
            class="mini-upload-pdf-icon"
            src="assets/icons/attachmentRed.svg"
            alt=""
            aria-hidden="true"
          />
        </ng-template>
      </ng-container>
      <ng-template #placeholder>
        <div class="mini-upload-square-placeholder">
          <span class="mini-upload-square-label" *ngIf="label">{{
            label
          }}</span>
          <img
            *ngIf="iconSrc || placeholderIconSrc; else paperclipIcon"
            class="mini-upload-clip"
            [src]="iconSrc || placeholderIconSrc"
            alt=""
            aria-hidden="true"
          />
          <ng-template #paperclipIcon>
            <svg
              class="mini-upload-clip"
              width="14"
              height="15"
              viewBox="0 0 12 13"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
              aria-hidden="true"
            >
              <path
                d="M3.15159 12.1403C3.57387 12.3622 4.00189 12.4441 4.50016 12.4027C4.87539 12.3699 5.13222 12.2957 5.43765 12.1339C5.84192 11.9185 5.77835 11.9893 8.30968 8.97258C10.3743 6.51209 10.6731 6.1461 10.8083 5.91597C11.2231 5.20449 11.3922 4.43574 11.3183 3.59147C11.2262 2.51249 10.7583 1.61492 9.93247 0.921963C9.13093 0.249387 8.18322 -0.0615561 7.14735 0.00881596C6.36648 0.0613782 5.71653 0.298291 5.06213 0.767405L4.78255 0.967412L2.39389 3.81411C0.0133765 6.65109 0.00522406 6.66081 0.00120285 6.76919C-0.0134297 7.01353 0.0890304 7.20712 0.297304 7.32394C0.453705 7.41378 0.591317 7.4175 0.764918 7.34379L0.91046 7.2838L3.15442 4.60956C4.61166 2.87288 5.45293 1.89003 5.55553 1.80228C6.00302 1.41204 6.52664 1.19743 7.16096 1.14193C8.00969 1.06768 8.69825 1.29777 9.30775 1.85886C9.87798 2.38287 10.169 3.00784 10.2134 3.79842C10.2428 4.3405 10.1007 4.92908 9.82557 5.38527C9.75698 5.50155 8.92699 6.51042 7.45548 8.2641C5.25432 10.8873 5.1826 10.9679 5.01008 11.0798C4.26674 11.5612 3.27861 11.1997 3.02003 10.3536C2.94172 10.1016 2.93771 9.84993 3.01292 9.57778L3.06516 9.37741L5.21341 6.79256C7.19861 4.40202 7.36331 4.20081 7.38559 4.09534C7.4682 3.67625 7.04926 3.31229 6.65253 3.45953L6.51757 3.51185L4.35921 6.08408C2.25792 8.5883 2.19717 8.66563 2.08639 8.89138C1.67547 9.75106 1.77727 10.7347 2.35491 11.4718C2.51982 11.6847 2.91817 12.019 3.15159 12.1403Z"
                fill="#707070"
              />
            </svg>
          </ng-template>
        </div>
      </ng-template>
    </ng-template>
  </label>

  <button
    *ngIf="!!value && !disabled && !hideInternalDelete"
    type="button"
    class="mini-upload-delete"
    (click)="onRemove($event)"
    title="Delete file"
  >
    <span class="material-symbols-rounded">delete</span>
  </button>
</div>
